import React from 'react';
import {BaseSettingsForm} from '@/components/forms';
import {Form, Col, Row} from 'react-bootstrap';
import {useStoreState} from 'easy-peasy';
import * as yup from 'yup';
import i18n from 'i18n';

interface TranscriptionTask {
    id: number;
    externalTaskId: string;
    status: string;
    eventCallId: number | null;
    type: string;
}

interface TranscriptionTasksSettingsFormProps {
    transcriptionTaskId: number;
}

interface FormValues {
    externalTaskId: string;
    status: string;
    eventCallId: number | null;
    type: string;
}

const TranscriptionTasksSettingsForm = React.memo<TranscriptionTasksSettingsFormProps>(({
    transcriptionTaskId,
}) => {
    const transcriptionTasks = useStoreState<{ transcriptionTasks: { items: TranscriptionTask[] } }>((state) => state.transcriptionTasks.items);
    const selectedTranscriptionTask = transcriptionTasks.find((transcriptionTask: TranscriptionTask) => transcriptionTask.id === transcriptionTaskId);

    const initialValues: FormValues = selectedTranscriptionTask || {
        externalTaskId: '',
        status: '',
        eventCallId: null,
        type: '',
    };

    // Read-only form - no actual CRUD operations
    const customSubmissionHandler = async () => {
        // No-op for read-only form
        return {data: initialValues};
    };

    const validationSchema = yup.object({
        externalTaskId: yup.string(),
        status: yup.string(),
        eventCallId: yup.number().nullable(),
        type: yup.string(),
    });

    return (
        <BaseSettingsForm
            entityId={transcriptionTaskId}
            resourceUrl="" // Not used with customSubmissionHandler
            storeActionPath="" // Not used with customSubmissionHandler
            validationSchema={validationSchema}
            initialValues={initialValues}
            successMessageKey=""
            customSubmissionHandler={customSubmissionHandler}
        >
            {(formik, loading) => (
                <>
                    <Row>
                        <Col xs={12}>
                            <Form.Group className="mb-3" controlId="externalTaskId" >
                                <Form.Label>{i18n.t('jt_task_external.text')}</Form.Label>
                                <Form.Control
                                    name="externalTaskId"
                                    value={formik.values.externalTaskId}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12}>
                            <Form.Group className="mb-3" controlId="status" >
                                <Form.Label>{i18n.t('jt_task_status.text')}</Form.Label>
                                <Form.Control
                                    name="status"
                                    value={formik.values.status}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12}>
                            <Form.Group className="mb-3" controlId="eventCallId" >
                                <Form.Label>{i18n.t('jt_event_call.text')}</Form.Label>
                                <Form.Control
                                    name="eventCallId"
                                    value={formik.values.eventCallId || ''}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                    </Row >

                    <Row>
                        <Col xs={12}>
                            <Form.Group className="mb-3" controlId="type" >
                                <Form.Label>{i18n.t('jt_task_type.text')}</Form.Label>
                                <Form.Control
                                    name="type"
                                    value={formik.values.type}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                    </Row >
                </>
            )}
        </BaseSettingsForm >
    );
});

export default TranscriptionTasksSettingsForm; 